import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { FormSubmissionDetailViewTopBar } from "./TopBar"

export const formSubmissionDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: FormSubmissionDetailViewTopBar,
}
